import React from 'react';
const DebugPill = ({ style, ...props }) => (React.createElement("div", { style: {
        backgroundColor: 'green',
        borderRadius: '1000px',
        padding: '4px 12px',
        margin: '8px',
        fontSize: '12px',
        color: 'white',
        boxShadow: '0 0 4px #0003',
        display: 'inline-block',
        zIndex: '100',
        ...(style || {})
    }, ...props }));
export default DebugPill;
//# sourceMappingURL=debug-pill.js.map